/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_ParticipantInputs */

const en_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Contributors`)
};

const ar_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المشاركونالمشاركون`)
};

const de_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Teilnehmer`)
};

const es_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuyentes actuales`)
};

const fr_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contributeurs actuels`)
};

const it_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donatori attuali`)
};

const ja_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の寄付者数`)
};

const ko_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 기부자 수`)
};

const pt_br_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuidores atuais`)
};

const ru_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущие участники`)
};

const th_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำนวนผู้บริจาคในขณะนี้`)
};

const tr_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mevcut Katılımcılar`)
};

const zh_cn_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前捐赠人数`)
};

const zh_tw_earth_day_2025_participant = /** @type {(inputs: Earth_Day_2025_ParticipantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前捐贈人數`)
};

/**
* | output |
* | --- |
* | "Current Contributors" |
*
* @param {Earth_Day_2025_ParticipantInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_participant = /** @type {((inputs?: Earth_Day_2025_ParticipantInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_ParticipantInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_participant(inputs)
	if (locale === "ar") return ar_earth_day_2025_participant(inputs)
	if (locale === "de") return de_earth_day_2025_participant(inputs)
	if (locale === "es") return es_earth_day_2025_participant(inputs)
	if (locale === "fr") return fr_earth_day_2025_participant(inputs)
	if (locale === "it") return it_earth_day_2025_participant(inputs)
	if (locale === "ja") return ja_earth_day_2025_participant(inputs)
	if (locale === "ko") return ko_earth_day_2025_participant(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_participant(inputs)
	if (locale === "ru") return ru_earth_day_2025_participant(inputs)
	if (locale === "th") return th_earth_day_2025_participant(inputs)
	if (locale === "tr") return tr_earth_day_2025_participant(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_participant(inputs)
	return zh_tw_earth_day_2025_participant(inputs)
});